import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import ButtonType from "%/dynamic-component-editor/options/button-type";
import IconPosition from "%/dynamic-component-editor/options/icon-position";
import TextOption from "%/dynamic-component-editor/options/text-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import ButtonSize from "%/dynamic-component-editor/options/button-size";
import Prefix from "%/dynamic-component-editor/options/prefix";
import Suffix from "%/dynamic-component-editor/options/suffix";
import Icon from "%/dynamic-component-editor/options/icon";
import IconSize from "%/dynamic-component-editor/options/icon-size";
import DisplayIcon from "%/dynamic-component-editor/options/display-icon";
import CountColor from "%/dynamic-component-editor/options/count-color";
import CountSize from "%/dynamic-component-editor/options/count-size";
import FontSize from "%/dynamic-component-editor/options/font-size";
import FontColor from "%/dynamic-component-editor/options/font-color";
import IconColor from "%/dynamic-component-editor/options/icon-color";
import DisplayValue from "%/dynamic-component-editor/options/display-value";

export default class ButtonActionOptions extends BaseOptionsBundle {

  optionTitle = "Action Button";
  static optionClassName = "i-dynamic-action-button";
  inspectorToolGroup = "action-button";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.ACTION_BUTTON_TOOL_SET,
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new ButtonType(undefined, hideFromInspector["button-type"] ?? false),
      new ButtonSize(undefined, hideFromInspector["button-size"] ?? false),
      new TextOption(undefined, hideFromInspector["text-option"] ?? false),
      new Icon(undefined, hideFromInspector["icon"] ?? false),
      IconColor,
      new IconSize(undefined, hideFromInspector["icon-size"] ?? false),
      new IconPosition(undefined, hideFromInspector["icon-position"] ?? false),
      DisplayIcon,
      DisplayValue,
      CountColor,
      CountSize,
      new Prefix(undefined, hideFromInspector["prefix"] ?? false),
      new Suffix(undefined, hideFromInspector["suffix"] ?? false),
      FontSize,
      FontColor,
    ]);
  }
}
